export default "__VITE_ASSET__Otd3kXO2__"